var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('pad-login',{on:{"login":function($event){_vm.show = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }